import { Avatar, Box } from "@mui/material";
import { ChatRoleBadge } from "Components/Chat/ChatRoleBadge";
import type { AccessRoleCode } from "Models/AccessRoleCodes";

const AVATAR_SIZE = 40;

type Props = {
  avatarImage: string | undefined;
  displayName: string;
  accessRole: AccessRoleCode | undefined;
  isOnline: boolean;
};

/** A direct conversation's avatar in the channel header: the counterpart, their role badge and presence. */
export const ChatHeaderDirectAvatar = ({
  avatarImage,
  displayName,
  accessRole,
  isOnline,
}: Props) => (
  <Box position="relative" flexShrink={0}>
    <Avatar
      src={avatarImage}
      alt={displayName}
      sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE }}
    />
    <ChatRoleBadge accessRole={accessRole} avatarSize={AVATAR_SIZE} />
    <Box
      position="absolute"
      bottom={0}
      right={0}
      width={12}
      height={12}
      borderRadius="50%"
      border="2px solid"
      borderColor="primary.main"
      bgcolor={isOnline ? "success.main" : "grey.400"}
    />
  </Box>
);
